<template>
  <ApolloMutation
    :mutation="(gql) => query"
    @error="snackbar = true"
    :variables="{
      id: id,
    }"
    :update="updateCache"
  >
    <template v-slot="{ mutate, loading, error }">
      <v-btn
        color="secondaryAction"
        small
        fab
        elevation="0"
        :disabled="loading"
        :loading="loading"
        @click="mutate()"
      >
        <v-icon>mdi-minus</v-icon>
      </v-btn>
      <v-snackbar v-model="snackbar" multi-line>
        {{ error }}
        <template v-slot:action="{ attrs }">
          <v-btn color="red" text v-bind="attrs" @click="snackbar = false">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </template>
      </v-snackbar>
    </template>
  </ApolloMutation>
</template>
<script>
import StoryMutations from "@/graphql/StoryMutations";
export default {
  props: {
    id: String,
  },
  data() {
    return {
      snackbar: false,
    };
  },
  methods: {
    updateCache(
      store,
      {
        data: {
          deleteStoryContribution: { storyContribution },
        },
      }
    ) {
      const normalizedId = store.identify({
        id: storyContribution.id,
        __typename: "StoryContribution",
      });
      store.evict({ id: normalizedId });
      store.gc();
    },
  },
  computed: {
    query() {
      return StoryMutations.deleteStoryContribution;
    },
  },
};
</script>
